import { UserTag } from '@kcftech/prometheus-client';
import { useQuery } from '@tanstack/react-query';
import { sdClient } from 'contexts/SDKClientContext';
import { useCallback } from 'react';

export const DESK_CHAT_DISPLAY_NAME = 'Resolve';

async function fetchDeskChatUserIds(): Promise<ReadonlySet<string>> {
    const response = await sdClient.getUserIdsByTag({ tag: UserTag.DeskChat });
    return new Set(response);
}

export function useIsDeskChatUser(): (userId: string | undefined) => boolean {
    const userIds = useQuery({
        queryKey: ['deskChatUserIds'],
        queryFn: fetchDeskChatUserIds,
        gcTime: Infinity,
        staleTime: Infinity,
    });

    return useCallback(
        (userId: string | undefined) => !!userId && !!userIds.data?.has(userId),
        [userIds.data],
    );
}
